/*
 * @Author: linyu
 * @Date: 2024-09-03 16:07:41
 * @LastEditors: linyu
 * @LastEditTime: 2024-09-03 16:07:41
 * @Description: 校验函数集合
 */

/**
 * 显示服务器返回的错误信息
 * @param arrField
 * @param objErrorMsg
 */
function displayServerError(arrField, objErrorMsg) {
    if (objErrorMsg) {
        Object.keys(objErrorMsg).forEach(function (key) {
            let errItem = arrField.filter((item) => (item.prop.indexOf(key) >= 0));
            if (errItem.length) {
                errItem[0].validateMessage = objErrorMsg[key];
                errItem[0].validateState = 'error';
            }
        });
        focusErrorInput();
    }
}

function focusErrorInput() {
    // 把光标定在第一个错误处
    setTimeout(function () {
        let isError = document.getElementsByClassName("is-error");
        if (isError && isError.length) {
            let objInput = isError[0].querySelector('input');
            if (objInput) {
                objInput.focus();
            }
        }
    }, 200);
}

export default {
    displayServerError,
    focusErrorInput,
}